/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import { StackView } from '@veeam/components';

export const LOGIN_FORM_WIDTH = 320;

export const FormContainer = styled(StackView)`
    [data-selector-id='form-layout'] > [direction='column'] > [data-selector-id='field'] > [data-field-control-container='true'] {
        width: ${LOGIN_FORM_WIDTH}px;
    }
`;
